import {kSystemIcons} from "../../../constants/icons";
import {SystemPrimaryCustomButton, SystemTertiaryCustomButton} from "../../buttons/SystemCustomButton";
import {kButtonStyles} from "../../../constants/styles";
import SystemCustomDivider from "../../dividers/SystemCustomDivider";
import LevelABlockDivider from "../../dividers/LevelABlockDivider";

export default function LevelAFlashSection({isBrevetDisplay, launchFlash}) {
    // Used in LevelAFlashExerciserButtons to display LevelA launch flash
    // block

    // BUILD
    return (
        <div className={"w-full flex flex-col justify-start items-center"}>
            <LevelABlockDivider />
            <div className={"w-full bg-primaryDark4/20 border-[1px] border-greyLight3 px-[12px] py-[12px] rounded-[12px]"}>
                <div className={"w-full flex flex-col justify-start items-start"}>
                    <div className={"w-full flex justify-between items-center"}>
                        <span className={"text-[16px] font-medium text-greyLight7"}>
                            {"3. Tester ma compréhension"}
                        </span>
                        {isBrevetDisplay
                            ? <SystemTertiaryCustomButton
                                label={"Lancer"}
                                isDisabled={false}
                                isLoading={false}
                                isFullWidth={false}
                                sizeStyle={kButtonStyles.smallButtonStyle}
                                onButtonClick={launchFlash} />
                            : <SystemPrimaryCustomButton
                                label={"Lancer un Flash"}
                                isDisabled={false}
                                isLoading={false}
                                isFullWidth={false}
                                icon={kSystemIcons.bolt}
                                sizeStyle={kButtonStyles.smallButtonStyle}
                                onButtonClick={launchFlash} />
                        }
                    </div>
                    <SystemCustomDivider color={"bg-greyLight3"} extraClass={"mt-[12px]"} />
                    <span className={"mt-[12px] text-[16px] text-greyLight9 font-medium whitespace-pre-line"}>
                        {"À toi de prouver que tu as compris la connaissance et que tu sais l'appliquer à une série de questions.\nDans ce QCM de 10 questions, trouve la bonne réponse parmi les 3 propositions. La correction est accessible à la fin du Flash et te permet de comprendre toutes tes erreurs."}
                    </span>
                </div>
            </div>
        </div>
    );
}